import {Logger} from '@nestjs/common';
import * as Rx from 'rxjs';
import * as RainbowSDK from 'rainbow-node-sdk';
import {Subject, Subscription} from 'rxjs';
import {takeUntil} from "rxjs/operators";
const { version } = require('../package.json');
import {inspect} from 'util';
import Bubble = Rainbow.Bubble;

export class RainbowService { 
    _sdk:Rainbow.SDK;
    _options:RainbowOptions;
    _events: { [key: string]: Subject<any> } = {};
    _me:Rainbow.Contact ;
    _adminBubble: Rainbow.Bubble ;
    portalIsReachable: boolean = false;
    noEventDebugMsg:string[] = [Rainbow.EVENT.onmessagereceiptreceived, Rainbow.EVENT.onmessagereceiptreadreceived, Rainbow.EVENT.onmessageserverreceiptreceived,
        Rainbow.EVENT.onchatstate, Rainbow.EVENT.oncontactpresencechanged];
    
    public sdk():Rainbow.SDK {return this._sdk};

    constructor(options: RainbowOptions) { //private options: RainbowOptions
        this._options = options;
        this._sdk =   new RainbowSDK(options);
        Logger.log(`SDK RainbowService ${version} initialised, RB version ` + this._sdk.version, "@ale-de/"+ this.constructor.name);
        this.setupEvents();
    }

    get adminBubbleJid() {return this._adminBubble.jid}

    setupEvents() {
        Logger.log('Setting up events ...',"@ale-de/"+this.constructor.name);
        for (let e in Rainbow.EVENT) {
            this._events[(Rainbow.EVENT as any)[e]] = new Subject<any>();
            switch ((Rainbow.EVENT as any)[e]) {
                case Rainbow.EVENT.onmessagereceived:
                    this._sdk.events.on((Rainbow.EVENT as any)[e], (res:any) => {
                        if (!this.noEventDebugMsg.includes((Rainbow.EVENT as any)[e]))
                            Logger.warn(`RB Event ${e} received`, "@ale-de/"+this.constructor.name);
                        let msg = res;
                        let rbMsg = new RBmsg();
                        rbMsg.fromJid = msg.fromJid;
                        rbMsg.attachment = msg.oob;
                        rbMsg.txt = msg.content;
                        rbMsg.conversation = msg.conversation;
                        try {
                            rbMsg.altContent = JSON.parse(msg.alternativeContent);
                        }catch (e) {
                            rbMsg.altContent = msg.alternativeContent;
                        }
                        if (msg.type === "groupchat") {
                            //console.log("groupchat", rbMsg);
                            rbMsg.fromJid = msg.fromBubbleUserJid.substring(0, msg.fromBubbleUserJid.indexOf("/"));
                            let user = rbMsg.conversation.bubble.users.find((u:any)=>u.jid_im==rbMsg.fromJid);
                            if (user) {
                                rbMsg.fromId = user.userId
                            }
                            rbMsg.isBubbleMsg = true;
                            rbMsg.bubbleJid = msg.fromBubbleJid;
                            if (rbMsg.bubbleJid === this._adminBubble.jid) rbMsg.isAdminMsg = true;
                        } else {
                            rbMsg.fromContact = rbMsg.conversation.contact;
                            rbMsg.fromId = rbMsg.fromContact.id;
                            rbMsg.fromJid = rbMsg.fromContact.jid;
                        }
                        this._events[(Rainbow.EVENT as any)[e]].next(rbMsg);
                    });
                    break;
                default:
                    this._sdk.events.on((Rainbow.EVENT as any)[e], (res:any) => {
                        if (!this.noEventDebugMsg.includes((Rainbow.EVENT as any)[e]))
                            Logger.warn(`RB Event ${e} received`, "@ale-de/"+ this.constructor.name);
                        this._events[(Rainbow.EVENT as any)[e]].next(res);
                    });
            
            }
        }
        Logger.log('Setting up events completed',"@ale-de/"+this.constructor.name);
    }

    //Set up the admin bubble
    setupAdminBubble(BOTadminbubble:any, BOTadminjid:any) {
        return new Promise((resolve, reject) => {
            this.createAdminBubble(this.me.firstName + "::" + BOTadminbubble, "Admin bubble to manage the bot.")
                .then((_) => {
                    //debug.log("Admin bubble up and running");
                    if (this._adminBubble.users.map(e => e.jid_im).indexOf(BOTadminjid) == -1) {
                        this.addContactToAdminBubble(BOTadminjid).then(ct => {
                            //debug.log("Super admin " + ct.displayName + " added to AdminBubble");
                            resolve(true);
                        }).catch(_ => {
                            //debug.log("Super admin not added to Admin bubble");
                            resolve(false);
                        });
                    } else {
                        //debug.log("Super admin present in bubble");
                        resolve(true);
                    }
                })
                .catch(_ => {
                    Logger.log("Admin bubble create error", "@ale-de/"+this.constructor.name);
                    reject(false);
                })
        })
    }

    public get me() {return this._me};
    public get version() {return this._sdk.version}

    unsubscribeAllEvents: Subject<any> = new Subject();

    subscribe(event:Rainbow.EVENT, callback:any):Subscription {
        return this._events[event]
            .pipe(takeUntil(this.unsubscribeAllEvents))
            .subscribe(callback);
    }

    //Functions
    start() {
        return new Promise((resolve, reject) => {
            this._sdk.start().then((res:any) => {
                //debug.log("Rainbow JID:" + this.me.jid_im);
                resolve(res);
            }).catch((err:any) => reject(err));
        });
    }
    signin() {
        this._sdk.rest.signin();
    }
    stop() {
        return new Promise((resolve, reject) => {
            this.unsubscribeAllEvents.next();
            this.unsubscribeAllEvents.complete();
            this._sdk.stop().then((res:any) => {
                resolve(res);
            }).catch((err:any) => reject(err));
        })
    }

    pollConnectionWithPortal() {
        return Rx.Observable.create((observer: { next: (arg0: { (): void; (): void; }) => void; }) => {
            let portalPoller = setInterval(() => {
                this._sdk.rest.checkPortalHealth()
                    .then((result:any) => {
                        if (startPollerMsg) {
                            startPollerMsg();
                            startPollerMsg = ()=>{};
                        }
                        return result;
                    })
                    .then((result:any) => {
                        if (result.status == 'OK') {
                            this.portalIsReachable = true;
                            //debug.log("Poll status:", result.status);
                        } else {
                            //debug.log("Poll status:", result.status);
                            this.portalIsReachable = false;
                            observer.next(stopInterval);
                        }
                    })
                    .catch((_) => {
                        Logger.error("Poll error:", "@ale-de/"+this.constructor.name);
                        this.portalIsReachable = false;
                        observer.next(stopInterval);
                    });
            }, 60000);
            let stopInterval = () => {
                clearInterval(portalPoller);
                Logger.log("Poller stopped","@ale-de/"+this.constructor.name)
            };
            let startPollerMsg = () => {
                Logger.log('Poller started',"@ale-de/"+this.constructor.name)
            };
        })
    }


    im(jid:any, msg:any, bubble = '', lang='en') {
        return new Promise((resolve, reject) => {
            if (!bubble)
                this._sdk.im.sendMessageToJid(msg, jid, lang).then(res => {
                    resolve(res);
                }).catch((err:any) => reject(err));
            if (bubble)
                this._sdk.im.sendMessageToBubbleJid(msg, bubble, lang).then(res => {
                    resolve(res);
                }).catch((err:any) => reject(err))
        });
    }

    fim(jid, msg, fmsg, title, bubble = '') {
        return new Promise((resolve, reject) => {
            if (!bubble)
                this._sdk.im.sendMessageToJid(msg, jid, "en", {
                    "type": "text/markdown",
                    "message": fmsg
                }, title).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
            if (bubble)
                this._sdk.im.sendMessageToBubbleJid(msg, bubble, 'en', {
                    "type": "text/markdown",
                    "message": fmsg
                }, title).then(res => {
                    resolve(res);
                }).catch(err => reject(err));
        })
    }

    bim(bjid, msg) {
        return new Promise((resolve, reject) => {
            this._sdk.im.sendMessageToBubbleJid(msg, bjid, 'en').then(res => {
                resolve(res);
            }).catch(err => reject(err))
        })
    }

    fbim(bjid, msg, fmsg, title) {
        return new Promise((resolve, reject) => {
            this._sdk.im.sendMessageToBubbleJid(msg, bjid, 'en', {
                "type": "text/markdown",
                "message": fmsg
            }, title).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        })
    }

    createGuestAccount(expTime) {
        //in minutes
        return new Promise<any>((resolve, reject) => {
            this._sdk.admin.createAnonymousGuestUser(expTime*60).then(ct => {
                resolve(ct);
            }).catch(err => {
                reject(err)
            });
        });
    }

    createUserAccount(email, passwd,firstName, lastName) {
        return new Promise<any>((resolve, reject) => {
            this._sdk.admin.createUserInCompany(email,passwd,firstName, lastName).then(ct => {
                resolve(ct);
            }).catch(err => {
                reject(err)
            });
        });
    }

    getContactByEmail(email) {
        return new Promise((resolve, reject) => {
            this._sdk.contacts.getContactByLoginEmail(email).then(ct => {
                resolve(ct);
            }).catch(err => {
                reject(err)
            })
        });
    }

    getContactByJid(jid) {
        return new Promise<any>((resolve, reject) => {
            this._sdk.contacts.getContactByJid(jid).then(ct => {
                resolve(ct);
            }).catch(err => {
                reject(err)
            })
        });
    }

    addToContacts(ct) {
        return new Promise((resolve, reject) => {
            this._sdk.contacts.addToContactsList(ct).then(c => {
                resolve(c);
            }).catch(err => {
                reject(err)
            });
        })
    }

    createGroup(name, comment) {
        return new Promise((resolve, reject) => {
            this._sdk.groups.createGroup(name, comment, false).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    addContactToGroup(contact, group) {
        return new Promise((resolve, reject) => {
            this._sdk.groups.addUserInGroup(contact, group).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    getGroup(name) {
        return new Promise((resolve, reject) => {
            /*
            this._sdk.groups.getGroupByName(name).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
            */
            //debug.log('Group', {group: this._sdk.groups.getGroupByName(name)});
            resolve(this._sdk.groups.getGroupByName(name));
        });
    }

    createPublicChannel(name, description) {
        return new Promise((resolve, reject) => {
            this._sdk.channels.createPublicChannel(name, description).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    createPrivateChannel(name, description) {
        return new Promise<any>((resolve, reject) => {
            this._sdk.channels.createClosedChannel(name, description).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    addOneMemberToChannel(user, channel) {
        return new Promise((resolve, reject) => {
            this._sdk.channels.addMembersToChannel(channel, [user]).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    addMembersToChannel(users, channel) {
        return new Promise((resolve, reject) => {
            this._sdk.channels.addMembersToChannel(channel, users).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    getChannel(name) {
        return new Promise<any>((resolve, reject) => {
            this._sdk.channels.findChannelsByName(name).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    deleteChannel(channel) {
        return new Promise<any>((resolve, reject) => {
            this._sdk.channels.deleteChannel(channel).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    deleteAllChannels() {
        let promises: Promise<any>[] = [];
        this.getAllChannels().forEach(channel=>promises.push(this.deleteChannel(channel)));
        return Promise.all(promises);
    }

    getAllChannels() {
        return this._sdk.channels.getAllChannels();
    }

    getChannelUsersByName(channelName) {
        return new Promise((resolve, reject) => {
            this.getChannel(channelName).then((ch: any) => {
                this._sdk.channels.fetchChannelUsers(ch).then(data => {
                    resolve(data)
                }).catch(err => {
                    reject(err)
                })
            });
        })
    }

    getChannelUsers(channel):Promise<any> {
        return new Promise((resolve, reject) => {
            this._sdk.channels.fetchChannelUsers(channel).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        });
    }

    publishMsgToChannel(channel, message, title = "", url = "") {
        return new Promise((resolve, reject) => {
            this._sdk.channels.publishMessageToChannel(channel, message, title, url).then(data => {
                resolve(data)
            }).catch(err => {
                reject(err)
            });
        })
    }

    inviteToRainbow(email, txt) {
        return new Promise((resolve, reject) => {
            this._sdk.admin.inviteUserInCompany(email, this._me.companyId, "en-US", txt)
                .then(result => {
                    resolve(result)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    broadcast(jidusers, msg) {
        return new Promise((resolve, reject) => {
            let promises:Promise<any>[] = [];
            jidusers.forEach(jid => {
                promises.push(new Promise((resolve, reject) => {
                    this._sdk.im.sendMessageToJid(msg, jid).then(res => {
                        resolve(true);
                    }).catch(err => resolve(jid));
                }))
            });
            Logger.log("Starting broadcast to group ...", "@ale-de/"+this.constructor.name);
            setTimeout(() => {
                Promise.all(promises).then(results => {
                    resolve(results);
                })
            }, 1000);
        });
    }

    createAdminBubble(name, desc) {
        return new Promise<any>((resolve, reject) => {
            this._adminBubble = this._sdk.bubbles.getAll().find(bubble => bubble.name == name);
            //debug(this.adminBubble);
            if (!this._adminBubble) {
                this._sdk.bubbles.createBubble(name, desc, true)
                    .then(res => {
                        this._adminBubble = res;
                        resolve(true);
                    })
                    .catch(err => {
                        reject(err)
                    })
            } else {
                resolve(false)
            }
        })
    }

    addContactToAdminBubble(jid) {
        return new Promise<any>((resolve, reject) => {
            this._sdk.contacts.getContactByJid(jid).then(ct => {
                this._sdk.bubbles.inviteContactToBubble(ct, this._adminBubble, false, false)
                    .then(bubble => {
                        resolve(ct);
                    })
                    .catch(err => reject(err))
            }).catch(err => reject(err))
        })
    }

    groupbroadcast(jidusers, msg) {
        return new Promise((resolve, reject) => {
            let promises:Promise<any>[] = [];
            jidusers.forEach(jid => {
                promises.push(new Promise((resolve, reject) => {
                    this._sdk.im.sendMessageToJid(msg, jid).then(res => {
                        Logger.log(`msg sent to ${jid}`, "@ale-de/"+this.constructor.name);
                        resolve(true);
                    }).catch(err => resolve(false));
                }))
            });
            Logger.log("Starting broadcast to group ...", "@ale-de/"+this.constructor.name);
            setTimeout(() => {
                Promise.all(promises).then(results => {
                    resolve(results);
                })
            }, 1000);
        });
    }

    async groupbroadcast2(jidusers, msg) {
        let cnt = 0;
        for (let jid of jidusers){
            let res = await this._sdk.im.sendMessageToJid(msg, jid);
            if (res) ++cnt;
        }
        return [jidusers.length,cnt]
    }

    getFile(fileInfo) {
        return new Promise((resolve, reject)=>{
            this._sdk.fileServer.getFileFromUrlWithOptimization('./thisfile',fileInfo.url,fileInfo.mime)
                .then(buf=>resolve(buf)).catch(err=>reject(err));
        });
    }

    retrieveFile(fileInfo) {
        return new Promise((resolve, reject) => {
            //debug.log("Getting File with info:", JSON.stringify(fileInfo));
            this.getFile(fileInfo).then(buf => {
                resolve(buf);
            }).catch(err => {
                //debug.log("getFile error:", err);
                reject({source: "getFile", error: err})
            })
        });
    }

    createCompany(companyName) {
        return new Promise((resolve, reject) => {
            this._sdk.admin.createCompany(companyName).then(data=>{resolve(data)}).catch(err=>{reject(err)})
        })
    }

    getCompany(companyName, userId) {
        return new Promise((resolve, reject) => {
            this._sdk.admin.getAllCompanies(userId)
                .then(data=>{
                    //debug.log("companies:", data);
                    resolve(data.data.find(c=>c.name==companyName))})
                .catch(err=>{reject(err)})
        })
    }

    getAllGuestUsers() {
        //  https://openrainbow.com/api/rainbow/admin/v1.0/users
        return new Promise((resolve, reject) => {
            this.restGet('/api/rainbow/admin/v1.0/users?roles=guest').then(res=> {
                //debug.log("Guest Users", {guestusers: res});
                resolve(res);
            }).catch(err=>reject(err))
        })
    }
    updateCompany(companyId, data) {
        return new Promise((resolve, reject) => {
            this.restPut('/api/rainbow/admin/v1.0/companies/'+companyId, data).then(res=>resolve(res))
                .catch(err=>reject(err))
        })
    }

    //roomTV
    //GET https://openrainbow.com/api/rainbow/tv/v1.0/tvs?format=full
    // POST https://openrainbow.com/api/rainbow/enduser/v1.0/rooms/5e60c9e21b8e4e488a03bc24/users {"userId":"5db867b516b25b22f7a3097e","privilege":"moderator","reason":"androidtv","status":"accepted"}
    addRoomTVtoBubble(bubble:Bubble, roomTVId):Promise<any> {
        return this.restPost(`/api/rainbow/enduser/v1.0/rooms/${bubble.id}/users`, {"userId":roomTVId,"privilege":"moderator","reason":"androidtv","status":"accepted"} )
    }

    restGet(url) {
        return new Promise((resolve, reject) => {
            this._sdk.rest.http.get(url, this._sdk.rest.getRequestHeader()).then((res)=> {
                Logger.warn('restGet result',   inspect({restGet: res}));
                resolve( res.data);
            }).catch( (err) => {
                reject(err);
            });
        })
    }

    restPut(url, data) {
        return new Promise((resolve, reject) => {
            this._sdk.rest.http.put(url, this._sdk.rest.getRequestHeader(), data).then((res)=> {
                resolve( res.data);
            }).catch( (err) => {
                reject(err);
            });
        })
    }

    restPost(url, data) {
        return new Promise((resolve, reject) => {
            this._sdk.rest.http.post(url, this._sdk.rest.getRequestHeader(), data).then((res)=> {
                resolve( res.data);
            }).catch( (err) => {
                reject(err);
            });
        })
    }
}


export class RainbowOptions {
    constructor(login: string, passwd:string, appID:string, appSecret:string, hostType:Rainbow.HOSTTYPE=Rainbow.HOSTTYPE.OFFICIAL){
        this.rainbow.host = hostType;
        this.credentials.login = login;
        this.credentials.password = passwd;
        this.application.appID = appID;
        this.application.appSecret = appSecret;
    }
    rainbow = {
        host: 'official',  // can be "sandbox" (developer platform), "official" or any other hostname when using dedicated AIO
    };

    credentials =  {
        login: '',
        password: ''
    };
    // Application identifier
    application = {
        'appID': '',
        'appSecret': '',
    };
    // Logs options
    logs = {
        enableConsoleLogs: false,            // Default: true
        enableFileLogs: true,              // Default: false
        file: {
            path: './logs/',   // Default path used
            level: 'debug'                  // Default log level used
        }
    };
    // IM options
    im = {
        sendReadReceipt: true   // True to send the the 'read' receipt automatically
    }
}


export class RBmsg {
    txt = '';
    altContent:any = '';
    bubbleJid = '';
    isBubbleMsg = false;
    isAdminMsg = false;
    fromContact: Rainbow.Contact;
    fromJid = '';
    fromId = '';
    conversation: Rainbow.Conversation;
    attachment = null;
    lang = 'en';
}

// Based on SDK 1.59.0
export namespace Rainbow {
   export interface SDK  {
        im
        channels:Channels
        contacts
        conversations
        presence
        bubbles
        groups
        events
        admin
        settings
        state
        version
        connectedUser
        telephony
        rest;
        fileServer;
        start()
        stop()
    }
    export interface Bubble {
        id
        name
        topic
        jid
        creator
        history
        users
        creationDate
        visibility
        customData
    }

    interface Channels { //1.59.0
        createChannel(name, channelTopic?) : Promise<Channel>
        createPublicChannel(name, channelTopic?, category?) : Promise<Channel>
        createClosedChannel (name, description?) : Promise<Channel>
        createClosedChannel (name, description?, category?) : Promise<Channel>
        deleteChannel(channel) : Promise<Channel>
        findChannelsByName(name) : Promise<Channel[]>
        findChannelsByTopic(topic) : Promise<Channel[]>
        getChannelById(id, force?) : Promise<Channel>
        fetchChannel(id, force?) : Promise<Channel>
        getAllChannels() : Channel[]
        getAllOwnedChannel() : Channel[]
        getAllOwnedChannels() : Channel[]
        getAllSubscribedChannel() : Channel[]
        getAllSubscribedChannels() : Channel[]
        getAllPendingChannels() : Channel[]
        publishMessageToChannel(channel, message, title?, url?, imagesIds?, type?) : Promise<any>
        createItem(channel, message, title?, url?, imagesIds?, type?) : Promise<any>
        subscribeToChannel(channel) : Promise<Channel>
        subscribeToChannelById(id) : Object
        unsubscribeFromChannel(channel) : Promise<String>
        updateChannelTopic(channel, description) : Promise<Channel>
        updateChannelDescription(channel, description) : Promise<Channel>
        updateChannelName(channel, channelName) : Channel
        updateChannel(id, channelTopic?, visibility?, max_items?, max_payload_size?, channelName?, category?) : Promise<Channel>
        updateChannelAvatar(channel, urlAvatar) : Channel
        deleteChannelAvatar(channel) : Channel
        fetchChannelUsers(channel, options?) : Promise<any[]>
        fetchChannelUsers(channel, options?) : Promise<any[]>
        removeAllUsersFromChannel(channel) : Promise<Channel>
        deleteAllUsersFromChannel(channel) : Promise<Channel>
        updateChannelUsers(channelId, users) : Promise<Channel>
        addOwnersToChannel(channel, owners) : Promise<Channel>
        addPublishersToChannel(channel, users) : Promise<Channel>
        addMembersToChannel(channel, users) : Promise<Channel>
        removeUsersFromChannel1(channel, users) : Promise<Channel>
        deleteUsersFromChannel(channel, users) : Promise<Channel>
        getMessagesFromChannel(channel) : Promise<any[]>
        fetchChannelItems(channel) : Promise<any[]>
        deleteMessageFromChannel(channelId, messageId) : Promise<Channel>
        deleteItemFromChannel(channelId, itemId) : Promise<Channel>
    }
    export interface Channel { //1.59.0
        name
        id
        visibility
        topic
        creatorId
        companyId
        creationDate
        type
        users_count
        subscribers_count
        category
        mode
    }
    export interface Contact {
        id
        name
        companyName
        loginEmail
        nickName
        title
        jobTitle
        country
        timezone
        organisationId
        siteId
        companyId
        jid_im
        jid
        jid_tel
        jidtel
        avatar
        lastAvatarUpdateDate
        lastUpdateDate
        adminType
        roles
        phoneNumbers
        phonePro
        phoneProCan
        phonePbx
        phoneInternalNumber
        pbxId
        mobilePro
        mobileProCan
        phonePerso
        phonePersoCan
        mobilePerso
        mobilePersoCan
        voicemailNumber
        emails
        emailPro
        emailPerso
        lastName
        firstName
        isTerminated
        language
        presence
        status
        resources
        nameUpdatePrio
        initials
        nickname
        roster
        displayName
    }
    export interface Conversation {
        id
        dbId
        type: Conversation.Type
        contact
        bubble
        capabilities
        avatar
        filterName
        missedCounter
        missedCalls
        messages
        status: Conversation.Status
        historyComplete
        lastModification
        creationDate
        lastMessageText
        lastMessageSender
        videoCall
        audioCall
        pstnConferenceSession
        webConferenceSession
    }
    export namespace Conversation {
        export enum Type {ONE_TO_ONE, ROOM, BOT}
        export enum Status {ACTIVE, INACTIVE, COMPOSING, PAUSED }
    }
    export interface Message {
        id
        fromJid
        side: Message.Side
        resource
        date
        toJid
        type: Message.Type
        content
        receiptStatus: Message.ReceiptStatus
        lang
        fileId
        cc
        cctype
        isEvent
        event
        alternativeContent
        isMarkdown
        subject
        oob
        fromBubbleJid
        fromBubbleUserJid
        getMessagesFromConversation(conversation, intNbMessage) : Promise<any>
        sendMessageToConversation(conversation, message, lang?, content?, subject?) : Promise<any>
        sendMessageToContact(message, contact, lang?, content?, subject?) : Promise<any>
        sendMessageToJid(message, jid, lang?, content?, subject?) : Promise<any>
        sendMessageToBubble(message, bubble, lang?, content?, subject?) : Promise<any>
        sendMessageToBubbleJid(message, jid, lang?, content?, subject?) : Promise<any>
        markMessageAsRead(messageReceived) : Promise<any>
    }
    export interface MessageContent {
        type:Message.ContentType,
        message: string
    }
    export namespace Message {
        export enum Type {CHAT, FILE, FS, WEBRTC, RECORDING}
        export enum ReceiptStatus {NONE, ERROR, IN_PROGRESS, SENT, UNREAD, READ}
        export enum Side {LEFT = 'L', RIGHT = 'R', ADMIN = 'ADMIN'}
        export type ContentType = 'text'|'markdown'
    }
    export enum EVENT {
        onmessageserverreceiptreceived='rainbow_onmessageserverreceiptreceived',
        onmessagereceiptreceived='rainbow_onmessagereceiptreceived',
        onmessagereceiptreadreceived='rainbow_onmessagereceiptreadreceived',
        onmessagereceived='rainbow_onmessagereceived',
        oncontactpresencechanged='rainbow_oncontactpresencechanged',
        onconversationremoved='rainbow_onconversationremoved',
        onconversationchanged='rainbow_onconversationchanged',
        onchatstate='rainbow_onchatstate',
        oncontactinformationchanged='rainbow_oncontactinformationchanged',
        onbubbleaffiliationchanged='rainbow_onbubbleaffiliationchanged',
        onbubbleownaffiliationchanged='rainbow_onbubbleownaffiliationchanged',
        onbubbleinvitationreceived='rainbow_onbubbleinvitationreceived',
        onbubblecustomdatachanged='rainbow_onbubblecustomdatachanged',
        bubbletopicchanged='rainbow_bubbletopicchanged',
        bubblenamechanged='rainbow_bubblenamechanged',
        ongroupcreated='rainbow_ongroupcreated',
        ongroupdeleted='rainbow_ongroupdeleted',
        ongroupupdated='rainbow_ongroupupdated',
        onuseraddedingroup='rainbow_onuseraddedingroup',
        onuserremovedfromgroup='rainbow_onuserremovedfromgroup',
        onchannelmessagereceived='rainbow_onchannelmessagereceived',
        onchannelmessagedeletedreceived='rainbow_onchannelmessagedeletedreceived',
        onprofilefeatureupdated='rainbow_onprofilefeatureupdated',
        oncallupdated='rainbow_oncallupdated',
        onvoicemessageupdated='rainbow_onvoicemessageupdated',
        oncallforwarded='rainbow_oncallforwarded',
        onfilecreated='rainbow_onfilecreated',
        onfileupdated='rainbow_onfileupdated',
        onfiledeleted='rainbow_onfiledeleted',
        onthumbnailcreated='rainbow_onthumbnailcreated',
        onchannelcreated='rainbow_onchannelcreated',
        onchanneldeleted='rainbow_onchanneldeleted',
        onstarted='rainbow_onstarted',
        onstopped='rainbow_onstopped',
        onconnected='rainbow_onconnected',
        onconnectionerror='rainbow_onconnectionerror',
        ondisconnected='rainbow_ondisconnected',
        onreconnecting='rainbow_onreconnecting',
        onfailed='rainbow_onfailed',
        onready='rainbow_onready',
        onerror='rainbow_onerror'
    }
    export enum HOSTTYPE {OFFICIAL='official', SANDBOX='sandbox'}
}
